import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryList`

export default defineMessages({
  currentSpendHeader: {
    id: `${scope}.currentSpendHeader`,
    defaultMessage: 'Current Spend',
  },
  emptyStateButtonText: {
    id: `${scope}.emptyStateButtonText`,
    defaultMessage: 'Budget',
  },
  oldEmptyStateButtonText: {
    id: `${scope}.oldEmptyStateButtonText`,
    defaultMessage: 'Budget Category',
  },
  emptyStateContent: {
    id: `${scope}.emptyStateContent`,
    defaultMessage:
      'Approvers will see spend reports while approving pending requests',
  },
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage: 'Start tracking spend by creating a budget',
  },
  oldEmptyStateHeader: {
    id: `${scope}.oldEmptyStateHeader`,
    defaultMessage: 'Start tracking spend by creating a budget category',
  },
  budgetHeader: {
    id: `${scope}.budgetHeader`,
    defaultMessage: 'Budget',
  },
  budgetCategoryHeader: {
    id: `${scope}.budgetCategoryHeader`,
    defaultMessage: 'Budget Category',
  },
  nameHeader: {
    id: `${scope}.nameHeader`,
    defaultMessage: 'Name',
  },
  percentageHeader: {
    id: `${scope}.percentageHeader`,
    defaultMessage: '%',
  },
  remainingHeader: {
    id: `${scope}.remainingHeader`,
    defaultMessage: 'Remaining',
  },
  varianceHeader: {
    id: `${scope}.varianceHeader`,
    defaultMessage: 'Variance',
  },
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Budget list table',
  },
  oldTableAriaLabel: {
    id: `${scope}.oldTableAriaLabel`,
    defaultMessage: 'Budget category list table',
  },
})
